import React, { PureComponent } from 'react';
import { Icon } from './elements';

class Youtube extends PureComponent {
  render() {
    return (
      <Icon viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M34.7686 5.62445C34.3661 3.76433 33.1801 2.29936 31.6743 1.8022C28.9448 0.898804 18 0.898804 18 0.898804C18 0.898804 7.05525 0.898804 4.32573 1.8022C2.81988 2.29944 1.63389 3.76433 1.23136 5.62445C0.5 8.99603 0.5 16.0305 0.5 16.0305C0.5 16.0305 0.5 23.065 1.23136 26.4366C1.63389 28.2967 2.81988 29.7006 4.32573 30.1978C7.05525 31.1012 18 31.1012 18 31.1012C18 31.1012 28.9447 31.1012 31.6743 30.1978C33.1801 29.7006 34.3661 28.2967 34.7686 26.4366C35.5 23.065 35.5 16.0305 35.5 16.0305C35.5 16.0305 35.5 8.99603 34.7686 5.62445ZM14.4204 22.4173V9.64373L23.5681 16.0307L14.4204 22.4173Z"
          fill="#033297"
        />
      </Icon>
    );
  }
}

export default Youtube;
